import { Injectable, WritableSignal, inject, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { TranslateService } from '@ngx-translate/core';

import { Globals } from '@core/globals';
import { GlobalsService } from '@services/globals.service';
import { RoutingService } from '@services/routing.service';
import { Language } from '@models/language.model';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private document = inject<Document>(DOCUMENT);
  private translateService = inject(TranslateService);
  private globalsService = inject(GlobalsService);
  private routingService = inject(RoutingService);

  private globals = inject(Globals);
  public language: WritableSignal<Language> = signal(this.globals.language());

  setLanguage(language: Language): void {
    this.routingService.setRoutes(language);
    this.document.documentElement.lang = language;
    this.globalsService.setHeaderHash(language);
    this.globals.language.set(language);
    this.translateService.use(language);
    this.language.set(language);
  }
}
